<template>
  <div>
    <div class="styTab">
      <div
        @click="handleSelBtn(item)"
        :class="`styTabsame ${
          item.id == btnAllInfo.isSel ? 'styTabsameActive' : ''
        }`"
        v-for="(item, index) in btnAllInfo.btnList"
        :key="index"
      >
        {{ item.title }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: {
    btnAllInfo: {
      type: Object,
      default: {
        isSel: 1,
        btnList: [
          {
            id: 1,
            title: "",
          },
        ],
      },
    },
  },
  methods: {
    handleSelBtn(item) {
      this.$emit("handleSelBtn", item);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>